import { useEffect, useState } from 'react'

export const useServerRendered = () => {
  const [isServerRendered, setIsServerRendered] = useState(false)

  useEffect(() => {
    setIsServerRendered(true)
  }, [])

  return isServerRendered
}
